<div class="db-payment-method-action">
  <div class="db-payment-method-action__info">
    <div class="mr20">
      <input class="ds-switcher-black ds-control-small" type="checkbox" id="payment_{{elementId}}" (change)="!needSetup && changeStatus()" [ngModel]="enabled">
      <label for="payment_{{elementId}}" [ngClass]="{'db-button_disabled': !!needSetup}">
        <span class="ds-switcher-control"></span>
      </label>
    </div>
    <div class="mr8">
      <i class="db-icon db-icon-ds-drag handle"></i>
    </div>
    <div class="db-payment-method-action__title">
      <p [innerHtml]="title"></p>
    </div>
  </div>
  <div class="db-payment-method-action__manage">
    <a
      dbWpLink
      [adminLink]="website?.adminEcommerceUrls['payment']"
      [websiteId]="website?.id"
      target="_blank" rel="noopener">{{ 'text_manage' | dbText }}</a>
  </div>
</div>
